import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Card, H3, H6, Button, Classes, Intent, FormGroup, InputGroup, TextArea } from '@blueprintjs/core';
import CorpusHeader from '../common/CorpusHeader';
import SavedQueriesTable from './SavedQueriesTable';
import { Dialog } from '@blueprintjs/core';

//import { refreshSignIn } from '../../../utils'

// structure de queries.json
// { name :  {"name":"", "date":"","tags":"","description":"","queries":"" } }


class SavedQueries extends React.PureComponent {

  state = {
    selectedQuery: {"name":"","keywords":"","description":"","query":""},
    isOpenModal: false,
    filter:"",
    modified:false,
    currentName:"",
  };


  onValueChange = (key,val) => {
    // console.log(key,val);
    const selectedQuery={...this.state.selectedQuery};
    selectedQuery[key]=val;
    this.setState({modified:true,selectedQuery:selectedQuery})
  }

  toggleSuppressModal = () => {
    this.setState(prevState => ({ isOpenSuppressModal: !prevState.isOpenSuppressModal }));
  }

  toggleNewQueryModal = () => {
    this.setState(prevState => ({ isOpenNewQueryModal: !prevState.isOpenNewQueryModal }));
  }

  
  handleSelectRow = (selectedQuery) => {
    this.setState({ selectedQuery: selectedQuery });
    // console.log(selectedQuery);
  }

  handleOnConfirmNewQuery =() => {
    this.toggleNewQueryModal();
    const savedQueries=this.props.savedQueries;
    const name = (this.state.currentName!=="")? this.state.currentName:this.getNewQueryName();
    const d=new Date();

    const date=(d.getYear()+1900).toString()+"-"+(d.getMonth()+1).toString()+"-"+(d.getDate()+1).toString();
    const selectedQuery = { name:name, date:date, description:"",keywords:"",query:""};
    savedQueries[name]=selectedQuery;
    this.saveQueries(savedQueries);
    this.setState({ selectedQuery: selectedQuery, currentName:"" });
  }


  handleOnConfirmSuppressQuery =() => {
    this.toggleSuppressModal();
   

    const savedQueries=this.props.savedQueries;
    delete(savedQueries[this.state.selectedQuery.name]);
    
    this.saveQueries(savedQueries);
    this.setState({ selectedQuery: null });
  }

  saveModifications=() => {
    const savedQueries=this.props.savedQueries;
    savedQueries[this.state.selectedQuery['name']]=this.state.selectedQuery;
    this.saveQueries(savedQueries);
  }

  saveQueries =(savedQueries)=> {
    const endpoint = '/save_user_data.ajax.php';

    const data={ 
      type:"queries",
      content:savedQueries,
    };

    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((data) => {
          this.setState({modified:false})
          this.props.refreshSavedData();
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
  };
  
  getNewQueryName=()=>{
    if (this.props.savedQueries) {
      return "query_"+Object.keys(this.props.savedQueries).length.toString();
    } else {
      return "";
    }
  }

  render() {
    const { selectedQuery, isOpenSuppressModal, isOpenNewQueryModal  } = this.state;
    const { t,savedQueries } = this.props;
    //const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    
    return (
      <>
        <CorpusHeader
          title={t('savedQueriesHeader')}
        />
        
        <FormGroup 
          label={t('filter')} 
          labelFor="filter" 
          inline={true}
          helperText={t('filterHelp')}
        >
          <InputGroup
            id="filter"
            value={this.state.filter}
            onChange={(e) => this.setState({ filter: e.target.value })}
          />
        </FormGroup>
        <div className="flex">

          <div className="flex-two-panels">
            <div className="padding-1-rem">
              {savedQueries && 
                <SavedQueriesTable
                  savedQueries={savedQueries}
                  onSelectRow={this.handleSelectRow}
                  filter={this.state.filter}
                />
              }
            </div>
            &nbsp;&nbsp;                  
            <center><Button text={t('addNewSavedQuery')} intent="primary" onClick={this.toggleNewQueryModal} /></center>

          </div>
          <div className="flex-two-panels">
            <div className="padding-1-rem">
              {this.state.selectedQuery && this.state.selectedQuery.name!=="" &&
                <Card elevation={2}>
                  <H3 className="margin-bottom-1-5rem">{selectedQuery.name}</H3>
                 
                  <H6>{t('recapInfo')}</H6>
                  <p>date: {this.state.selectedQuery.date}</p>
                  <FormGroup label={t('keywords')} labelFor="keywords">
                    <InputGroup id="keywords" value={this.state.selectedQuery.keywords} onChange={(e) => this.onValueChange('keywords', e.target.value)} />
                  </FormGroup>

                  <p>{t('description')}</p>

                  <TextArea
                    onChange={(e) => this.onValueChange('description', e.target.value)}
                    value={this.state.selectedQuery.description}
                    style={{'height': '143px', 'width': '600px'}}
                  />
                    
                  <p>{t('query')}</p>

                  <TextArea
                    onChange={(e) => this.onValueChange('query', e.target.value)}
                    value={this.state.selectedQuery.query}
                    style={{'height': '150px', 'width': '600px'}}
                  />


  
                  &nbsp;&nbsp;<br/>
                  
                  { this.state.modified && 
                    <Button text={t('saveModifications')} onClick={this.saveModifications} /> 
                  }
                  &nbsp;&nbsp;                  
                  <Button text={t('pasteThisQuery')} onClick={ ()=>this.props.pasteQuery(this.state.selectedQuery.query) } />
                  &nbsp;&nbsp;                  
                  <Button text={t('suppress')} intent="danger" onClick={this.toggleSuppressModal} />

                 </Card>
              }
            </div>
          </div>
        </div>
       
        <Dialog
            isOpen={isOpenNewQueryModal}
            onClose={this.toggleNewQueryModal}
            title={t('newSavedQuery')}
            style={{'width': '400px'}}  // 400px seems a good deal
          >
            <div className={Classes.DIALOG_BODY}>
              {t('newSavedQueryExplanation')}
              <FormGroup label={t('queryName')} labelFor="name">
                <InputGroup id="queryName" defaultValue={this.getNewQueryName()} onChange={(e) => { this.setState({'currentName':e.target.value}) }} />
              </FormGroup>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>

                <Button onClick={this.toggleNewQueryModal}>{t('close')}</Button>

                <Button
                    onClick={this.handleOnConfirmNewQuery}
                    intent={Intent.PRIMARY}
                >
                    {t('confirmAddNewQuery')}
                </Button>
              </div>
            </div>

          </Dialog>

        {selectedQuery &&
          <Dialog
            isOpen={isOpenSuppressModal}
            onClose={this.toggleSuppressModal}
            title={t('suppress')+" «"+selectedQuery.name+"»"}
            style={{'width': '400px'}}  // 400px seems a good deal
          >
            <div className={Classes.DIALOG_BODY}>
              {t('suppressQueriesExplanation')}
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>

                <Button onClick={this.toggleSuppressModal}>{t('close')}</Button>

                <Button
                    onClick={this.handleOnConfirmSuppressQuery}
                    intent={Intent.DANGER}
                >
                    {t('confirmSuppressing')}
                </Button>
              </div>
            </div>

          </Dialog>
        }
      </>
    );
  }
}

SavedQueries.propTypes = {
  savedQueries:PropTypes.object ,
  refreshSavedData:PropTypes.func,
  pasteQuery:PropTypes.func,
};

export default withTranslation()(SavedQueries);
